namespace Matrix.Rebalancer {
    export interface TaskTypePropertiesForm {
        TaskTypeCode: Serenity.StringEditor;
        PropertyName: Serenity.StringEditor;
        PropertyGroup: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        DataType: Serenity.LookupEditor;
        MinLength: Serenity.IntegerEditor;
        MaxLength: Serenity.IntegerEditor;
        MinValue: Serenity.DecimalEditor;
        MaxValue: Serenity.DecimalEditor;
        ListCode: Serenity.StringEditor;
        ListType: Serenity.StringEditor;
        ReadOnly: Serenity.BooleanEditor;
        Required: Serenity.BooleanEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class TaskTypePropertiesForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.TaskTypeProperties';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TaskTypePropertiesForm.init)  {
                TaskTypePropertiesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.BooleanEditor;
                var w5 = StaticTextBlock;
                var w6 = ReadOnlyDateTime;

                Q.initFormType(TaskTypePropertiesForm, [
                    'TaskTypeCode', w0,
                    'PropertyName', w0,
                    'PropertyGroup', w0,
                    'Description', w0,
                    'DataType', w1,
                    'MinLength', w2,
                    'MaxLength', w2,
                    'MinValue', w3,
                    'MaxValue', w3,
                    'ListCode', w0,
                    'ListType', w0,
                    'ReadOnly', w4,
                    'Required', w4,
                    'CreatedBy', w5,
                    'CreatedWhen', w6,
                    'UpdatedBy', w5,
                    'UpdatedWhen', w6,
                    'Version', w5
                ]);
            }
        }
    }
}
